import { Practitioner } from "./practitioner";
import { Treatment } from "./treatment";
import { Location } from "./location";

export class PractitionerTreatment {
  id: number;
  practitionerId: number;
  practitioner: Practitioner;
  treatmentId: number;
  treatment: Treatment;
  locationId: number;
  name: string;
  showData: boolean;
  location: Location;
  operationHours: any;
  treatmentType: any;
  treatmentTypeCount: number;
  treatmentTypeCommaSeperated: string;
}
